import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import Env from '../../env';
import { OidcAuthResponse, OidcAuthStartRequest, OidcAuthStartResponse } from '../ridango.models';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthDeviceContext, CapacitorDeviceService } from './capacitor-device.service';

@Injectable({
    providedIn: 'root'
})
export class OidcAuthService {
    constructor(
        @Inject('ENV') private readonly env: Env,
        private readonly http: HttpClient,
        private readonly capacitorDeviceService: CapacitorDeviceService
    ) {}

    start(providerName: string, lang?: string): Observable<OidcAuthStartResponse> {
        return this.capacitorDeviceService.getAuthDeviceContext().pipe(
            switchMap((deviceContext) => {
                const baseUrl = this.getBaseUrl();
                const requestBody = this.buildOidcAuthStartRequestBody(deviceContext, lang);
                const startUrl = `${baseUrl}/oidc/${providerName}/start`;
                return this.http
                    .post<OidcAuthStartResponse>(startUrl, requestBody)
                    .pipe(catchError((startError) => throwError(() => startError)));
            }),
            catchError((deviceContextError) => throwError(() => deviceContextError))
        );
    }

    private buildOidcAuthStartRequestBody(deviceContext: AuthDeviceContext, lang?: string): OidcAuthStartRequest {
        return {
            clientId: this.env.WMB?.AUTH?.CLIENT_ID ?? this.env.OAUTH_CLIENT_ID ?? '',
            redirectUri: this.env.OIDC_REDIRECT_URL ?? '',
            lang,
            channel: this.env.CHANNEL ?? '',
            customerDevice: {
                deviceId: deviceContext.deviceId,
                model: deviceContext.deviceModel,
                osVersion: deviceContext.osVersion
            }
        };
    }

    exchange(exchangeId: string): Observable<OidcAuthResponse> {
        const exchangeUrl = `${this.getBaseUrl()}/oidc/exchange/${exchangeId}`;
        return this.http
            .get<OidcAuthResponse>(exchangeUrl)
            .pipe(catchError((exchangeError) => throwError(() => exchangeError)));
    }

    private getBaseUrl(): string {
        return `${this.env.WMB.WMB_PUBLIC_API}/v1/auth`;
    }
}
